import { LinksSchemaType } from "../type";

export const trainLinksArray: LinksSchemaType = {
  main: "/train",
  maintitle: "صفحه اصلی قطار ",
  mainImage: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/train-desktop.png`,
  mainImageMobile: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/train-mobile.png`,
  noFollow: true,
  otherlinks: [
    {
      title: "قطار تهران به مشهد",
      href: "/train-ticket/Tehran/Mashhad",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran-mashhad.png`
    },
    {
      title: "قطار مشهد به تهران",
      href: "/train-ticket/Mashhad/Tehran",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/mashhad-tehran.png`
    },
    {
      title: "قطار تهران به قم",
      href: "/train-ticket/Tehran/Qom",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran-qom.png`
    },
    {
      title: "قطار قم به تهران",
      href: "/train-ticket/Qom/Tehran",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/qom-tehran.png`
    },
    {
      title: "قطار ماهشهر به کارون",
      href: "/train-ticket/Mahshahr/Karun",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/mahshahr-karon.png`
    },
    {
      title: "قطار کارون به ماهشهر",
      href: "/train-ticket/Karun/Mahshahr",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/karon-mahshahr.png`
    },
    {
      title: "قطار تهران به شیراز",
      href: "/train-ticket/Tehran/Shiraz",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran-shiraz.png`
    },
    {
      title: "قطار شیراز به تهران",
      href: "/train-ticket/Shiraz/Tehran",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/shiraz-tehran.png`
    },
    {
      title: "قطار تهران به اهواز",
      href: "/train-ticket/Tehran/Ahvaz",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran-ahvaz.png`
    },
    {
      title: "قطار اهواز به تهران",
      href: "/train-ticket/Ahvaz/Tehran",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/ahvaz-tehran.png`
    },
    {
      title: "قطار تهران به بندرعباس",
      href: "/train-ticket/Tehran/BandarAbbas",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran-bandarabbas.png`
    },
    {
      title: "قطار بندرعباس به تهران",
      href: "/train-ticket/BandarAbbas/Tehran",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/bandarabbas-tehran.png`
    }
  ]
};
